import { cancelMsg, t } from '../../common/i18n/index.js';
import { DialogWrapper } from '../DialogWrapper/index.js';

export interface LastItemRemovalDialogProps {
  isVisible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const LastItemRemovalDialog = ({ isVisible, onCancel, onConfirm }: LastItemRemovalDialogProps) => {
  if (!isVisible) {
    return null;
  }

  return (
    <DialogWrapper
      buttons={[
        {
          color: 'link',
          onClick: onCancel,
          text: t.B2V1(cancelMsg),
        },
        {
          onClick: onConfirm,
          text: t.FV8F('Remove item and return to shop'),
        },
      ]}
      closeable
      header={t.F97B('Are you sure you want to remove the last item from your cart?')}
      onCloseDialog={onCancel}
    />
  );
};
